import { withLocalState } from 'pyradux';

import BalanceContainer from './Balance.container';
import reducer from './Balance.reducer';
import BalanceSagas from './Balance.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'balance',
  sagas: [BalanceSagas],
};

export default withLocalState(withLocalStateOptions, BalanceContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Balance/index.js